import { render, staticRenderFns } from "./filter-item.vue?vue&type=template&id=a359ab36&scoped=true"
import script from "./filter-item.vue?vue&type=script&lang=js"
export * from "./filter-item.vue?vue&type=script&lang=js"
import style0 from "./filter-item.vue?vue&type=style&index=0&id=a359ab36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a359ab36",
  null
  
)

export default component.exports